export default __webpack_public_path__ + "static/media/sbnri.75dbd6e5.svg";